import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { PublicNavbar } from "./components/PublicNavbar"
import { Footer } from "./components/Footer"
import RegisterFarmer from "./pages/RegisterFarmer"

// Admin
import AdminLogin from "./admin/pages/Login"
import AdminLayout from "./admin/components/AdminLayout"
import ProtectedRoute from "./admin/components/ProtectedRoute"
import AdminDashboard from "./admin/pages/Dashboard"
import AdminFarmers  from "./admin/pages/Farmers"
import AdminMapView  from "./admin/pages/MapView"
import AdminTreeTypes from "./admin/pages/TreeTypes"
import FarmerDetail  from "./admin/pages/FarmerDetail"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/register"
          element={
            <div className="min-h-screen bg-[#111] flex flex-col">
              <PublicNavbar />
              <main className="flex-1">
                <RegisterFarmer />
              </main>
              <Footer />
            </div>
          }
        />

        <Route path="/admin/akm-login" element={<AdminLogin />} />
        <Route path="/admin/login" element={<Navigate to="/register" replace />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="farmers"    element={<AdminFarmers />} />
          <Route path="tree-types" element={<AdminTreeTypes />} />
          <Route path="farmers/:id" element={<FarmerDetail />} />
          <Route path="map" element={<AdminMapView />} />
        </Route>

        <Route path="/" element={<Navigate to="/register" replace />} />
        <Route path="*" element={<Navigate to="/register" replace />} />

      </Routes>
    </BrowserRouter>
  )
}

export default App